<template>
  <div v-if="allowedToShow"
       class="request-decline-approve-table-cell">
    <span class="buttons">
      <span @click="decline"
           class="button decline">{{$t('request.decline')}}</span>
      <div @click="approve"
           class="button approve">{{$t('request.approve')}}</div>
    </span>
  </div>
</template>

<script>

import store from '@/store';
import { CHANGE_REQUEST_STATUS } from '@/store/request/actionTypes';
import { requestStatuses } from '@/constants/requests';

export default {
  name: 'RequestDeclineApproveTableCell',
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    allowedToShow() {
      return this.item.status === requestStatuses.REQUESTED;
    },
  },
  methods: {
    decline() {
      const options = { id: this.item.id, status: requestStatuses.DECLINED };
      store.dispatch(CHANGE_REQUEST_STATUS, options);
    },
    approve() {
      const options = { id: this.item.id, status: requestStatuses.ACCEPTED };
      store.dispatch(CHANGE_REQUEST_STATUS, options);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.request-decline-approve-table-cell {
  font-size: rem(12);

  .button {
    display: inline;
    cursor: pointer;
    text-transform: uppercase;
    border-radius: $radius-sm;
    padding: rem(5) rem(12);
    margin-left: rem(12);
    box-shadow: 0 rem(1) rem(1) 0 rgba(0, 0, 0, 0.14), 0 rem(2) rem(1) rem(-1) rgba(0, 0, 0, 0.12), 0 rem(1) rem(3) 0 rgba(0, 0, 0, 0.2);

    &.decline {
      border: solid 1px var(--status-error);
      color: var(--status-error);
      &:hover {
        background-color: var(--status-error);
        color: var(--text-on-brand);
      }
    }
    &.approve {
      border: solid 1px var(--status-success);
      color: var(--status-success);
      &:hover {
        background-color: var(--status-success);
        color: var(--text-on-brand);
      }
    }
  }
}
